import React from 'react';
import './PickPackage.scss';
import PackageItem from 'Components/PickPackage/PackageItem';
import PriceItem from 'Components/Shared/PriceItem/PriceItem';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import PackageSubItem from 'Components/PickPackage/PackageSubItem';

interface IProps {
  totalPrice: number;
  performanceID: number;
  selectedPackages: Julius.Website.PackageRequestViewModel[];
  availablePackages: Julius.Website.PackageViewModel[];
  onPackageSelection: (selection: Julius.Website.PackageRequestViewModel) => void;
}

const PickPackage: React.SFC<IProps> = ({
  totalPrice,
  performanceID,
  selectedPackages,
  availablePackages,
  onPackageSelection,
}) => {

  if (!availablePackages || !availablePackages.length) {
    return null;
  }

  return (
    <div className='pick-package'>
      <FormattedText 
        style='title'
        displayName='Tillval'
        formattedName='order.extraitems.header'
      />
      { availablePackages.map((p, i) => p.maxNumberOfPackages > 0 &&
        <PackageItem key={ i } title={ p.title } text={ p.text }>
          { p.packageTypes.map((t, j) =>
            <PackageSubItem 
              key={ j } 
              name={ t.name }
              packageID={ p.packageID }
              performanceID={ performanceID }
              discountID={ t.discountID }
              maxNumberOfPackages={ p.maxNumberOfPackages }
              priceCategories={ t.priceCategories }
              sectionCategories={ t.sectionCategories }
              onPackageSelection={ onPackageSelection }
              currentSelection={
                selectedPackages && selectedPackages.find(selectedPackage => 
                  selectedPackage.packageID === p.packageID &&
                  selectedPackage.discountID === t.discountID) 
              }
            />)
          }
        </PackageItem>)
      }
      <div className='total-price bold'>
        <FormattedText
          displayName='Summa'
          formattedName='global.sum'
        />
        <PriceItem price={ totalPrice } decimals={ 2 } />
      </div>
    </div>
  );
}

export default PickPackage;


// WEBPACK FOOTER //
// ./src/components/PickPackage/PickPackage.tsx